export default __webpack_public_path__ + "locales/sq-AL/PeopleTranslations.json?hash=0d7e7644f611cc46042b51812120f030";